import { createBrowserRouter } from "react-router";
import { DuviNicheSiteHome } from "@/pages/duvi-niche-site-home";
import { DuviNicheSitePricing } from "@/pages/duvi-niche-site-pricing";

export const router = createBrowserRouter([
  { path: "/", element: <DuviNicheSiteHome /> },
  { path: "/pricing", element: <DuviNicheSitePricing /> },
]);
